// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   AUTH PAGES (Login/Signup) - Glassmorphism v1.1
   Using design-tokens.css throughout
   ============================================ */

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--bg-base);
  font-family: var(--font-primary);
  padding: var(--space-4);
}

.login-box {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  padding: var(--space-10);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: clamp(380px, 20vw, 450px);
  backdrop-filter: var(--glass-blur);
}

/* ============================================
   LOGO
   ============================================ */

.login-logo {
  margin-bottom: var(--space-6);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  justify-content: center;
  position: relative;
}

.login-rx-pill {
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--accent-primary);
  background: var(--accent-primary-muted);
  border: 1px solid var(--accent-primary-border);
  border-radius: var(--radius-full);
  padding: var(--space-2) var(--space-4);
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.login-debono {
  font-family: var(--font-primary);
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.28em;
  color: var(--text-primary);
  text-transform: uppercase;
  line-height: 1;
  position: relative;
  z-index: 1;
}

.login-favicon {
  position: absolute;
  top: var(--space-6);
  left: 50%;
  transform: translateX(-50%);
  height: clamp(39px, 2.4vw, 56px);
  width: clamp(39px, 2.4vw, 56px);
  opacity: 0.4;
  z-index: 0;
  pointer-events: none;
}

/* ============================================
   HEADING & TEXT
   ============================================ */

.login-box h2 {
  text-align: center;
  margin-bottom: var(--space-8);
  color: var(--text-secondary);
  font-size: var(--text-base);
  font-weight: var(--font-weight-normal);
}

/* ============================================
   FORM
   ============================================ */

.form-group {
  margin-bottom: var(--space-5);
}

.form-group label {
  display: block;
  margin-bottom: var(--space-2);
  color: var(--text-secondary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.form-group input {
  width: 100%;
  padding: var(--space-4);
  background: var(--bg-input);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  font-family: var(--font-primary);
  font-size: var(--text-base);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.form-group input::placeholder {
  color: var(--text-muted);
}

.form-group input:focus {
  outline: none;
  border-color: var(--accent-primary);
  background: var(--bg-input-focus);
  box-shadow: 0 0 0 3px var(--accent-primary-muted);
}

/* ============================================
   BUTTONS
   ============================================ */

.login-box button[type="submit"] {
  width: 100%;
  padding: var(--space-4);
  background: var(--accent-primary);
  color: var(--text-primary);
  border: none;
  border-radius: var(--radius-lg);
  font-family: var(--font-primary);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  margin-top: var(--space-4);
  transition: all var(--transition-fast);
}

.login-box button[type="submit"]:hover {
  background: var(--accent-primary-hover);
  transform: translateY(-2px);
  box-shadow: var(--shadow-glow);
}

.login-box button[type="submit"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.login-box button[type="submit"]:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* ============================================
   ERROR & SUCCESS MESSAGES
   ============================================ */

.error {
  color: #ef4444;
  margin-top: var(--space-2);
  text-align: center;
  padding: var(--space-4);
  background: var(--color-error-bg);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
}

.success-message {
  text-align: center;
  color: var(--color-physiology);
  padding: var(--space-5);
  background: var(--color-physiology-bg);
  border: 1px solid var(--color-physiology-border);
  border-radius: var(--radius-lg);
}

.success-message p {
  margin: var(--space-2) 0;
  font-size: var(--text-base);
}

/* ============================================
   OAUTH / GOOGLE SIGN-IN
   ============================================ */

.oauth-provider-row {
  display: flex;
  justify-content: center;
  margin: var(--space-4) 0;
}

.oauth-provider {
  display: flex;
  justify-content: center;
}

.oauth-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: var(--space-6) 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.oauth-divider::before,
.oauth-divider::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid var(--border-subtle);
}

.oauth-divider span {
  padding: 0 var(--space-4);
}

/* ============================================
   LINK TO OTHER AUTH PAGE
   ============================================ */

.login-box a {
  color: var(--accent-primary);
  text-decoration: none;
  font-size: var(--text-sm);
  transition: color var(--transition-fast);
}

.login-box a:hover {
  color: var(--accent-primary-hover);
  text-decoration: underline;
}

/* ============================================
   SIGNUP TERMS CHECKBOX
   ============================================ */

.signup-terms {
  margin-top: var(--space-4);
}

.signup-terms-label {
  display: flex !important;
  align-items: flex-start;
  gap: var(--space-3);
  cursor: pointer;
  font-size: var(--text-sm) !important;
  font-weight: var(--font-weight-normal) !important;
  color: var(--text-muted) !important;
  line-height: 1.5;
}

.signup-terms-label input[type="checkbox"] {
  width: auto;
  margin-top: 3px;
  accent-color: var(--accent-primary);
  cursor: pointer;
  flex-shrink: 0;
}

.signup-terms-label a {
  color: var(--accent-primary);
  text-decoration: none;
}

.signup-terms-label a:hover {
  text-decoration: underline;
}

/* ============================================
   DEV QUICK LOGIN
   ============================================ */

.dev-quick-login {
  margin-bottom: var(--space-6);
  padding: var(--space-4);
  background: rgba(34, 197, 94, 0.06);
  border: 1px dashed rgba(34, 197, 94, 0.3);
  border-radius: var(--radius-lg);
}

.dev-quick-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #4ade80;
  margin-bottom: var(--space-3);
  text-align: center;
}

.dev-quick-buttons {
  display: flex;
  gap: var(--space-2);
}

.dev-quick-btn {
  flex: 1 1;
  padding: var(--space-2) var(--space-3);
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.25);
  border-radius: var(--radius-md);
  color: #4ade80;
  font-size: var(--text-xs);
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms ease;
  font-family: var(--font-primary);
}

.dev-quick-btn:hover:not(:disabled) {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.5);
  transform: translateY(-1px);
}

.dev-quick-btn:disabled {
  opacity: 0.55;
  cursor: wait;
}

/* Fresh-account button — teal accent to visually distinguish from existing-account buttons */
.dev-quick-btn--fresh {
  background: rgba(45, 212, 191, 0.1);
  border-color: rgba(45, 212, 191, 0.3);
  color: #2dd4bf;
}

.dev-quick-btn--fresh:hover:not(:disabled) {
  background: rgba(45, 212, 191, 0.22);
  border-color: rgba(45, 212, 191, 0.55);
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 480px) {
  .login-box {
    padding: var(--space-6);
    border-radius: var(--radius-xl);
  }

  .login-debono {
    font-size: var(--text-2xl);
    letter-spacing: 0.2em;
  }

  .login-favicon {
    height: clamp(34px, 10vw, 48px);
    width: clamp(34px, 10vw, 48px);
  }
}

/* ============================================
   ACCESSIBILITY
   ============================================ */

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.form-group input:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.login-naplex-hint {
  text-align: center;
  color: #34d399;
  font-size: 0.875rem;
  font-weight: 500;
  margin: -0.25rem 0 0.75rem;
  letter-spacing: 0.01em;
}

.login-ptcb-hint {
  text-align: center;
  color: #93c5fd;
  font-size: 0.875rem;
  font-weight: 500;
  margin: -0.25rem 0 0.75rem;
  letter-spacing: 0.01em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;EACX,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,uCAAuC;EACvC,8CAA8C;EAC9C,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,oCAAoC;EACpC,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,wCAAwC;EACxC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,iDAAiD;EACjD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,6FAA6F;AAC7F;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB","sourcesContent":["/* ============================================\n   AUTH PAGES (Login/Signup) - Glassmorphism v1.1\n   Using design-tokens.css throughout\n   ============================================ */\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: var(--bg-base);\n  font-family: var(--font-primary);\n  padding: var(--space-4);\n}\n\n.login-box {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  padding: var(--space-10);\n  border-radius: var(--radius-2xl);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: clamp(380px, 20vw, 450px);\n  backdrop-filter: var(--glass-blur);\n}\n\n/* ============================================\n   LOGO\n   ============================================ */\n\n.login-logo {\n  margin-bottom: var(--space-6);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-3);\n  justify-content: center;\n  position: relative;\n}\n\n.login-rx-pill {\n  font-family: var(--font-primary);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-wide);\n  text-transform: uppercase;\n  color: var(--accent-primary);\n  background: var(--accent-primary-muted);\n  border: 1px solid var(--accent-primary-border);\n  border-radius: var(--radius-full);\n  padding: var(--space-2) var(--space-4);\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.login-debono {\n  font-family: var(--font-primary);\n  font-size: var(--text-3xl);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.28em;\n  color: var(--text-primary);\n  text-transform: uppercase;\n  line-height: 1;\n  position: relative;\n  z-index: 1;\n}\n\n.login-favicon {\n  position: absolute;\n  top: var(--space-6);\n  left: 50%;\n  transform: translateX(-50%);\n  height: clamp(39px, 2.4vw, 56px);\n  width: clamp(39px, 2.4vw, 56px);\n  opacity: 0.4;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* ============================================\n   HEADING & TEXT\n   ============================================ */\n\n.login-box h2 {\n  text-align: center;\n  margin-bottom: var(--space-8);\n  color: var(--text-secondary);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-normal);\n}\n\n/* ============================================\n   FORM\n   ============================================ */\n\n.form-group {\n  margin-bottom: var(--space-5);\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: var(--space-2);\n  color: var(--text-secondary);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.form-group input {\n  width: 100%;\n  padding: var(--space-4);\n  background: var(--bg-input);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  font-family: var(--font-primary);\n  font-size: var(--text-base);\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n}\n\n.form-group input::placeholder {\n  color: var(--text-muted);\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  background: var(--bg-input-focus);\n  box-shadow: 0 0 0 3px var(--accent-primary-muted);\n}\n\n/* ============================================\n   BUTTONS\n   ============================================ */\n\n.login-box button[type=\"submit\"] {\n  width: 100%;\n  padding: var(--space-4);\n  background: var(--accent-primary);\n  color: var(--text-primary);\n  border: none;\n  border-radius: var(--radius-lg);\n  font-family: var(--font-primary);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  margin-top: var(--space-4);\n  transition: all var(--transition-fast);\n}\n\n.login-box button[type=\"submit\"]:hover {\n  background: var(--accent-primary-hover);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-glow);\n}\n\n.login-box button[type=\"submit\"]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.login-box button[type=\"submit\"]:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* ============================================\n   ERROR & SUCCESS MESSAGES\n   ============================================ */\n\n.error {\n  color: #ef4444;\n  margin-top: var(--space-2);\n  text-align: center;\n  padding: var(--space-4);\n  background: var(--color-error-bg);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-sm);\n}\n\n.success-message {\n  text-align: center;\n  color: var(--color-physiology);\n  padding: var(--space-5);\n  background: var(--color-physiology-bg);\n  border: 1px solid var(--color-physiology-border);\n  border-radius: var(--radius-lg);\n}\n\n.success-message p {\n  margin: var(--space-2) 0;\n  font-size: var(--text-base);\n}\n\n/* ============================================\n   OAUTH / GOOGLE SIGN-IN\n   ============================================ */\n\n.oauth-provider-row {\n  display: flex;\n  justify-content: center;\n  margin: var(--space-4) 0;\n}\n\n.oauth-provider {\n  display: flex;\n  justify-content: center;\n}\n\n.oauth-divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: var(--space-6) 0;\n  color: var(--text-muted);\n  font-size: var(--text-sm);\n}\n\n.oauth-divider::before,\n.oauth-divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.oauth-divider span {\n  padding: 0 var(--space-4);\n}\n\n/* ============================================\n   LINK TO OTHER AUTH PAGE\n   ============================================ */\n\n.login-box a {\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: var(--text-sm);\n  transition: color var(--transition-fast);\n}\n\n.login-box a:hover {\n  color: var(--accent-primary-hover);\n  text-decoration: underline;\n}\n\n/* ============================================\n   SIGNUP TERMS CHECKBOX\n   ============================================ */\n\n.signup-terms {\n  margin-top: var(--space-4);\n}\n\n.signup-terms-label {\n  display: flex !important;\n  align-items: flex-start;\n  gap: var(--space-3);\n  cursor: pointer;\n  font-size: var(--text-sm) !important;\n  font-weight: var(--font-weight-normal) !important;\n  color: var(--text-muted) !important;\n  line-height: 1.5;\n}\n\n.signup-terms-label input[type=\"checkbox\"] {\n  width: auto;\n  margin-top: 3px;\n  accent-color: var(--accent-primary);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.signup-terms-label a {\n  color: var(--accent-primary);\n  text-decoration: none;\n}\n\n.signup-terms-label a:hover {\n  text-decoration: underline;\n}\n\n/* ============================================\n   DEV QUICK LOGIN\n   ============================================ */\n\n.dev-quick-login {\n  margin-bottom: var(--space-6);\n  padding: var(--space-4);\n  background: rgba(34, 197, 94, 0.06);\n  border: 1px dashed rgba(34, 197, 94, 0.3);\n  border-radius: var(--radius-lg);\n}\n\n.dev-quick-label {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: #4ade80;\n  margin-bottom: var(--space-3);\n  text-align: center;\n}\n\n.dev-quick-buttons {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.dev-quick-btn {\n  flex: 1;\n  padding: var(--space-2) var(--space-3);\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.25);\n  border-radius: var(--radius-md);\n  color: #4ade80;\n  font-size: var(--text-xs);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms ease;\n  font-family: var(--font-primary);\n}\n\n.dev-quick-btn:hover:not(:disabled) {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: rgba(34, 197, 94, 0.5);\n  transform: translateY(-1px);\n}\n\n.dev-quick-btn:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n/* Fresh-account button — teal accent to visually distinguish from existing-account buttons */\n.dev-quick-btn--fresh {\n  background: rgba(45, 212, 191, 0.1);\n  border-color: rgba(45, 212, 191, 0.3);\n  color: #2dd4bf;\n}\n\n.dev-quick-btn--fresh:hover:not(:disabled) {\n  background: rgba(45, 212, 191, 0.22);\n  border-color: rgba(45, 212, 191, 0.55);\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 480px) {\n  .login-box {\n    padding: var(--space-6);\n    border-radius: var(--radius-xl);\n  }\n\n  .login-debono {\n    font-size: var(--text-2xl);\n    letter-spacing: 0.2em;\n  }\n\n  .login-favicon {\n    height: clamp(34px, 10vw, 48px);\n    width: clamp(34px, 10vw, 48px);\n  }\n}\n\n/* ============================================\n   ACCESSIBILITY\n   ============================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n.form-group input:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.login-naplex-hint {\n  text-align: center;\n  color: #34d399;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: -0.25rem 0 0.75rem;\n  letter-spacing: 0.01em;\n}\n\n.login-ptcb-hint {\n  text-align: center;\n  color: #93c5fd;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: -0.25rem 0 0.75rem;\n  letter-spacing: 0.01em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
